import { render, staticRenderFns } from "./Recuento.vue?vue&type=template&id=6ecd2466"
import script from "./Recuento.vue?vue&type=script&lang=js"
export * from "./Recuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports